<template lang="pug">
    label.vm-label
        slot
</template>

<script>
export default {
    name: 'vm_label',
};
</script>

<style lang="stylus" scoped></style>
